var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 109.353,
    height: 60,
    viewBox: "0 0 109.353 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 65.616,
    height: 29.886,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105",
    transform: "translate(-8775 177)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100",
    "data-name": "Rectangle 100",
    width: 109.353,
    height: 60,
    transform: "translate(8775 -177)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104",
    transform: "translate(8796.504 -160.945)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M1079.13,236.471h3.465a5.886,5.886,0,0,1,3.006.6,2.037,2.037,0,0,1,.981,1.871,2.36,2.36,0,0,1-.428,1.426,1.907,1.907,0,0,1-1.127.762v.068a2.31,2.31,0,0,1,1.338.815,2.458,2.458,0,0,1,.415,1.48,2.537,2.537,0,0,1-1.015,2.13,4.446,4.446,0,0,1-2.768.778h-3.865Zm2.683,3.811h.808a1.457,1.457,0,0,0,.893-.238.828.828,0,0,0,.316-.706q0-.836-1.263-.836h-.754Zm0,1.963v2.086h.944q1.257,0,1.256-1.06a.912.912,0,0,0-.336-.761,1.548,1.548,0,0,0-.975-.265Z",
    transform: "translate(-1079.131 -236.329)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M1103.77,236.471v5.978a4.011,4.011,0,0,1-1.1,3.019,4.392,4.392,0,0,1-3.182,1.07,4.347,4.347,0,0,1-3.121-1.039,3.934,3.934,0,0,1-1.09-2.989v-6.039h2.7V242.3a2.387,2.387,0,0,0,.394,1.528,1.7,1.7,0,0,0,2.354,0,2.529,2.529,0,0,0,.37-1.545v-5.814Z",
    transform: "translate(-1086.078 -236.329)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M1119.778,243.278a2.925,2.925,0,0,1-.469,1.64,3.059,3.059,0,0,1-1.352,1.114,5,5,0,0,1-2.072.4,8.325,8.325,0,0,1-1.664-.141,6.11,6.11,0,0,1-1.4-.485v-2.391a8,8,0,0,0,1.6.615,5.964,5.964,0,0,0,1.522.221,1.474,1.474,0,0,0,.876-.208.638.638,0,0,0,.279-.533.588.588,0,0,0-.112-.357,1.293,1.293,0,0,0-.36-.309q-.248-.157-1.321-.639a6.278,6.278,0,0,1-1.457-.856,2.617,2.617,0,0,1-.72-.951,3.16,3.16,0,0,1-.235-1.27,2.546,2.546,0,0,1,1-2.141,4.4,4.4,0,0,1,2.745-.768,7.71,7.71,0,0,1,3.145.713l-.821,2.072a5.956,5.956,0,0,0-2.405-.639,1.253,1.253,0,0,0-.761.184.556.556,0,0,0-.238.455.659.659,0,0,0,.3.523,11.547,11.547,0,0,0,1.64.841,4.546,4.546,0,0,1,1.783,1.24,2.691,2.691,0,0,1,.5,1.668",
    transform: "translate(-1093.632 -236.221)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 2.696,
    height: 9.931,
    transform: "translate(27.542 0.142)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M1145.2,246.4h-3.519l-3.627-7h-.061q.129,1.65.129,2.52V246.4h-2.377v-9.931h3.505l3.614,6.9h.041q-.1-1.5-.1-2.412v-4.49h2.391Z",
    transform: "translate(-1103.498 -236.329)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M1161.789,246.4h-5.9v-9.931h5.9v2.154h-3.213v1.562h2.975v2.153h-2.975v1.875h3.213Z",
    transform: "translate(-1112.17 -236.329)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M1175.223,243.278a2.924,2.924,0,0,1-.469,1.64,3.057,3.057,0,0,1-1.352,1.114,5,5,0,0,1-2.072.4,8.318,8.318,0,0,1-1.664-.141,6.116,6.116,0,0,1-1.4-.485v-2.391a8,8,0,0,0,1.6.615,5.967,5.967,0,0,0,1.522.221,1.475,1.475,0,0,0,.876-.208.637.637,0,0,0,.278-.533.587.587,0,0,0-.112-.357,1.288,1.288,0,0,0-.361-.309,14.609,14.609,0,0,0-1.321-.639,6.272,6.272,0,0,1-1.457-.856,2.629,2.629,0,0,1-.72-.951,3.152,3.152,0,0,1-.235-1.27,2.546,2.546,0,0,1,1-2.141,4.4,4.4,0,0,1,2.745-.768,7.709,7.709,0,0,1,3.145.713l-.822,2.072a5.952,5.952,0,0,0-2.4-.639,1.253,1.253,0,0,0-.761.184.556.556,0,0,0-.238.455.659.659,0,0,0,.3.523,11.555,11.555,0,0,0,1.64.841,4.554,4.554,0,0,1,1.783,1.24,2.692,2.692,0,0,1,.5,1.668",
    transform: "translate(-1117.496 -236.221)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M1189.075,243.278a2.92,2.92,0,0,1-.469,1.64,3.06,3.06,0,0,1-1.351,1.114,4.992,4.992,0,0,1-2.073.4,8.321,8.321,0,0,1-1.663-.141,6.093,6.093,0,0,1-1.4-.485v-2.391a7.983,7.983,0,0,0,1.6.615,5.951,5.951,0,0,0,1.521.221,1.473,1.473,0,0,0,.875-.208.635.635,0,0,0,.279-.533.584.584,0,0,0-.112-.357,1.292,1.292,0,0,0-.359-.309q-.248-.157-1.321-.639a6.264,6.264,0,0,1-1.458-.856,2.628,2.628,0,0,1-.719-.951,3.148,3.148,0,0,1-.235-1.27,2.545,2.545,0,0,1,1-2.141,4.4,4.4,0,0,1,2.744-.768,7.71,7.71,0,0,1,3.145.713l-.821,2.072a5.961,5.961,0,0,0-2.405-.639,1.255,1.255,0,0,0-.761.184.556.556,0,0,0-.238.455.658.658,0,0,0,.3.523,11.5,11.5,0,0,0,1.64.841,4.544,4.544,0,0,1,1.783,1.24,2.688,2.688,0,0,1,.5,1.668",
    transform: "translate(-1123.459 -236.221)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M1080.777,278.829a6.562,6.562,0,0,1-1.393-.143V276.6c.145.027.3.058.462.092a2.677,2.677,0,0,0,.53.05,1.086,1.086,0,0,0,.951-.4,2.456,2.456,0,0,0,.285-1.372V265.78h2.7v8.96a4.6,4.6,0,0,1-.883,3.054,3.291,3.291,0,0,1-2.649,1.036",
    transform: "translate(-1079.24 -248.944)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M1100.57,270.614a5.355,5.355,0,0,1-1.229,3.811,5.586,5.586,0,0,1-7.183-.007,6.435,6.435,0,0,1-.006-7.6,5.621,5.621,0,0,1,7.2-.01,5.363,5.363,0,0,1,1.222,3.811m-6.833,0q0,2.881,2,2.88a1.724,1.724,0,0,0,1.512-.7,5.082,5.082,0,0,0-.007-4.378,1.705,1.705,0,0,0-1.491-.71q-2.017,0-2.017,2.907",
    transform: "translate(-1084.201 -248.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M1116.694,275.711h-5.9V265.78h5.9v2.153h-3.213V269.5h2.975v2.154h-2.975v1.875h3.213Z",
    transform: "translate(-1092.761 -248.944)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M1133.438,275.711h-3.519l-3.627-7h-.061q.129,1.65.129,2.52v4.476h-2.377V265.78h3.505l3.614,6.9h.041q-.1-1.5-.1-2.412V265.78h2.391Z",
    transform: "translate(-1098.436 -248.944)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M1150.277,272.587a2.926,2.926,0,0,1-.469,1.64,3.061,3.061,0,0,1-1.352,1.114,4.993,4.993,0,0,1-2.072.4,8.371,8.371,0,0,1-1.664-.14,6.11,6.11,0,0,1-1.4-.485v-2.391a8,8,0,0,0,1.6.615,5.939,5.939,0,0,0,1.522.221,1.476,1.476,0,0,0,.876-.207.637.637,0,0,0,.279-.533.587.587,0,0,0-.112-.357,1.305,1.305,0,0,0-.36-.309q-.249-.156-1.322-.639a6.337,6.337,0,0,1-1.457-.856,2.614,2.614,0,0,1-.72-.951,3.158,3.158,0,0,1-.235-1.27,2.545,2.545,0,0,1,1-2.14,4.4,4.4,0,0,1,2.745-.768,7.708,7.708,0,0,1,3.145.713l-.822,2.072a5.951,5.951,0,0,0-2.4-.638,1.253,1.253,0,0,0-.761.183.556.556,0,0,0-.238.455.657.657,0,0,0,.3.523,11.468,11.468,0,0,0,1.64.842,4.541,4.541,0,0,1,1.783,1.241,2.691,2.691,0,0,1,.5,1.667",
    transform: "translate(-1106.759 -248.836)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M1166.387,265.78v5.978a4.011,4.011,0,0,1-1.1,3.019,4.395,4.395,0,0,1-3.182,1.07,4.347,4.347,0,0,1-3.121-1.04,3.934,3.934,0,0,1-1.09-2.989V265.78h2.7v5.827a2.385,2.385,0,0,0,.394,1.529,1.7,1.7,0,0,0,2.354,0,2.529,2.529,0,0,0,.37-1.545V265.78Z",
    transform: "translate(-1113.03 -248.944)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M1184.651,265.78v5.978a4.012,4.012,0,0,1-1.1,3.019,4.392,4.392,0,0,1-3.182,1.07,4.346,4.346,0,0,1-3.121-1.04,3.935,3.935,0,0,1-1.091-2.989V265.78h2.7v5.827a2.388,2.388,0,0,0,.394,1.529,1.7,1.7,0,0,0,2.354,0,2.524,2.524,0,0,0,.37-1.545V265.78Z",
    transform: "translate(-1120.891 -248.944)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7cfdb96bc31fdf6a1625aeefcb76f83c.svg";
export { ForwardRef as ReactComponent };